import { GetAppointmentById } from '~/domain/usecases/appointment/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteGetAppointmentById implements GetAppointmentById {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAppointmentById.Model>;

  constructor(url: string, httpClient: HttpClient<GetAppointmentById.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  getAppointmentById = async (
    params: GetAppointmentById.Params,
  ): Promise<GetAppointmentById.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.id}`,
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
